import type { FunctionComponent } from 'react';

import { CopyContent, Price } from '@kanda-libs/ks-design-library';

import { formatPriceForDisplay } from 'common/helpers';
import Profile from 'components/shared/Profile';

export interface SolarTradeInfoProps {
  /**
   * Company trade type
   */
  tradeType?: string;
  /**
   * Company solar trade body
   */
  solarTrade?: string;
  /**
   * Company solar trade body number
   */
  solarTradeNumber?: string;
  /**
   * Company electrical trade body
   */
  elecTrade?: string;
  /**
   * Company electrical trade body number
   */
  elecTradeNumber?: string;
  /**
   * Company EPVS registration number
   */
  epvs?: string;
  /**
   * Company average job value
   */
  avgJobValue?: number;
  /**
   * Company average monthly no. jobs
   */
  avgMonthly?: number;
  /**
   * Company warranty length
   */
  warrantyLength?: number;
  /**
   * Company sues subcontractors
   */
  useSubs?: string;
  /**
   * Company referral code
   */
  referral?: string;
}

const SolarTradeInfo: FunctionComponent<SolarTradeInfoProps> = function ({
  tradeType = '',
  solarTrade = '',
  solarTradeNumber = '',
  elecTrade = '',
  elecTradeNumber = '',
  epvs = '',
  avgJobValue = 0,
  avgMonthly = 0,
  warrantyLength = 0,
  useSubs,
  referral,
}) {
  return (
    <Profile.Section className="pb-4 mb-6">
      <Profile.Property
        label="Trade type"
        value={tradeType.split('_').join(' ')}
      />
      <Profile.Property label="Solar Trade body" value={solarTrade} />
      <Profile.Property label="Solar Trade num" value={solarTradeNumber} />
      <Profile.Property label="Elec. Trade body" value={elecTrade} />
      <Profile.Property label="Elect. Trade num" value={elecTradeNumber} />
      <Profile.Property label="EPVS cert num" value={epvs} />
      <Profile.Property label="Avg. job value">
        <CopyContent
          content={formatPriceForDisplay(avgJobValue ? avgJobValue / 100 : 0)}
        >
          <Price
            amount={avgJobValue}
            poundsClassName="text-14-22 text-neutral-700"
            centsClassName="text-14-22 text-neutral-700"
          />
        </CopyContent>
      </Profile.Property>
      <Profile.Property label="Avg. jobs/month" value={avgMonthly} />
      <Profile.Property
        label="Warranty length"
        value={`${warrantyLength} months`}
      />
      <Profile.Property label="Subcontracts" value={useSubs} />
      <Profile.Property label="Referral code" value={referral} />
    </Profile.Section>
  );
};

export default SolarTradeInfo;
